import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { InterviewService } from "@App/interview.service";
import { Account, SectionProgress } from "@Models";
import { InterviewSectionActionService, ObservableService } from "@Services";
import { take } from "rxjs";
import { SubSink } from "subsink";
import InterviewProgressService from "./interview-progress.service";
import { SharedModule } from "@Shared/shared.module";

@Component({
    selector: 'interview-progress',
    templateUrl: './interview-progress.component.html',
    styleUrls: ['./interview-progress.component.scss'],
    imports: [SharedModule]
})
export default class InterviewProgress implements OnInit, OnDestroy {
    @Input() account: Account;

    sections: SectionProgress[];
    displaySections: SectionProgress[];
    activeSectionName: string;

    subs = new SubSink();
    isOpen = false;
    
    constructor(public interviewProgressService: InterviewProgressService,
        public interviewService: InterviewService,
        public observableService: ObservableService,
        public interviewSectionActionService: InterviewSectionActionService
    ){

    }

    ngOnInit(): void {
        this.initializeSections(false);

        this.subs.add(this.observableService.onCaseStarted.pipe(take(1)).subscribe(()=> {            
            this.initializeSections(false);
        }));
  
        this.subs.add(this.observableService.onCaseRestarted.pipe(take(1)).subscribe(()=> {            
            this.initializeSections(true);
        }));

        this.subs.add(this.observableService.onCaseQuestionProgress.subscribe(()=> {
            setTimeout(() => {
                this.updateSections();
            },100);
        }));

        this.subs.add(this.observableService.onMrasQuestionProgress.subscribe((progress: number)=> {
            setTimeout(() => {
                this.updateMrasSection(progress);
            },100);
        }));

        this.subs.add(this.interviewService.updatedInterview.subscribe(() =>{
            setTimeout(() => {
                this.updateSections();
            },100);
        }));
    }

    updateMrasSection(progress: number) {        
        const activeSection = this.interviewService.getActiveSection();
        const displaySection = this.displaySections.find(x => x.sectionId === activeSection.id);

        displaySection.progress = progress;
    }

    updateSections(){
        const interviewData = this.interviewService.getInterviewData();
        const visibleSections = interviewData.visibleSections;

        const activeSection = this.interviewService.getActiveSection();
        this.activeSectionName = activeSection?.header ? activeSection?.header : activeSection?.name;

        

        this.sections.filter(x => x.order < activeSection.order).forEach(x=> {
            x.progress = 100;                    
        });

        this.sections.filter(x => x.order > activeSection.order).forEach(x=> {
            x.progress = 0;                    
        });

        if (!activeSection.isThirdParty) {
            this.interviewProgressService.updateSection(activeSection, visibleSections); 
        }        

        this.filterVisibleSections();

        this.displaySections = this.displaySections.filter(x => {
            const section = interviewData.sections.find(y => y.id === x.sectionId);
            
            if (section && section.status === 'DONOT_PROCESS'){
                return false;
            }

            return true;
        });
        
        this.displaySections.sort((x, y) => x.order - y.order);

        this.displaySections.forEach(x => {
            if (x.order < activeSection.order) {
                x.isEnabled = true;
            }else{
                x.isEnabled = false;
            }

            if (x.sectionId === activeSection.id) {
                x.isActive = true;
                x.isEnabled = true;
            }else{
                x.isActive = false;
            }
        });
    }

    initializeSections(isRestart){
        const interviewData = this.interviewService.getInterviewData();
        this.interviewProgressService.getApplicationProgress(this.account.id, this.account.versionNumber, interviewData?.caseDetails?.id).subscribe(result => {
            this.interviewProgressService.sections = result;
            this.sections = this.interviewProgressService.sections;
            if (interviewData) {
                this.updateSections();
            }else{
                const visibleSections = this.interviewSectionActionService.sectionSummaries;

                if (!visibleSections || visibleSections.length <=0){
                    return;
                }

                this.filterVisibleSections();

                this.displaySections.sort((x, y) => x.order - y.order);
                let enabledSectionIdx = 0;

                if (isRestart) {
                    const section = this.displaySections.find(x => x.sectionId === interviewData.activeSectionId);
                    enabledSectionIdx = this.displaySections.indexOf(section);

                    this.activeSectionName = section.name;
                }

                this.displaySections.forEach((x, idx) => {       
                    if (idx === enabledSectionIdx) {
                        x.isEnabled = true;
                        x.isActive = true;
                    }else{
                        x.isEnabled = false;
                    }
                });
            }
        });
    }

    filterVisibleSections(){
        const visibleSections = this.interviewSectionActionService.sectionSummaries;

        this.displaySections = this.sections.filter(x => {
            if (visibleSections.find(y => y.id === x.sectionId))
                return true;

            return false;
        });
    }

    selectSection(selectedSection: SectionProgress){
        if (selectedSection.isEnabled && !selectedSection.isActive) {
            const visibleSections = this.interviewSectionActionService.sectionSummaries;
            const section = visibleSections.find(x => x.id === selectedSection.sectionId);

            this.observableService.onSectionSelected.next(section);
            this.isOpen =false;
        }        
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}